<template>
    <el-dialog
        title="进群审批"
        :height="50"
        :max-height="500"
        :visible.sync="dialogShow"
        custom-class="group_verify_popup"
        :before-close="onBeforeClose">
        <div class="verifys">
            <el-table :data="groupVerifyList"
                :header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
                <div slot="empty">
                    <img :src="require(`@/assets/image/empty.png`)" style="width: 100%;padding: 15px 0;"/>
                </div>
                <!-- <el-table-column width="40">
                    <template slot="header">
                        <el-checkbox v-model="checked" :indeterminate="indeterminate" @change="checkAll"></el-checkbox>
                    </template>
                    <template slot-scope="scope" v-if="scope.row.status == 1">
                        <el-checkbox v-model="scope.row.checked" @change="changeSingle"></el-checkbox>
                    </template>
                </el-table-column> -->
                <el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in VerifyHeaderList"
                    :type="item.prop" :key="index" :width="item.width" align="center">
                    <template slot-scope="scope">
                        <div class="user-info" v-if="item.prop == 'nickname'">
                            <img class="avatar" :src="scope.row['avatar_url']" alt="">
                            {{scope.row[item.prop]}}
                        </div>
                        <template v-else-if="item.prop == 'status'">
                            <span v-if="scope.row[item.prop] == 1">待审批</span>
                            <span v-if="scope.row[item.prop] == 2">已同意</span>
                            <span v-if="scope.row[item.prop] == 3">已拒绝</span>
                        </template>
                        <span v-else>{{scope.row[item.prop]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope" v-if="scope.row.status == 1">
                        <span class="alink" @click="edit(scope.row, 2)">同意</span>
                        <span class="alink" @click="edit(scope.row, 3)">拒绝</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 计步器 -->
        <el-pagination
            style="margin-top: 30px;"
            background
            layout="prev, pager, next"
            :page-count="page.total_page"
            :current-page="page.page"
            @current-change="onChangeCurrent"
            @prev-click="onChangeCurrent(page.page - 1)"
            @next-click="onChangeCurrent(page.page + 1)">
        </el-pagination>
        
        <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="$emit('change', false)">取 消</el-button>
            <el-button type="primary" @click="agreeAll">全部同意</el-button>
        </span> -->
    </el-dialog>
</template>

<script>
    export default{
        name: 'groupverify',
        data(){
            return{
                VerifyHeaderList: [
					{
                        prop: 'nickname',
                        label: '用户信息'
                    },
                    {
                        prop: 'status',
                        label: '状态'
                    },
                    {
                        prop: 'created_time',
                        label: '申请时间'
                    },
				],
                checked: false,
                indeterminate: false,
            }
        },
        props: {
            dialogShow: {
                type: Boolean,
                default: false
            },
            groupVerifyList: {
                type: Array,
                default: () => []
            },
            page: {
                type: Object,
                default: () => {
                    return { page_size: 10, page: 0, has_more: false, warrant_id: 0 }
                }
            }
        },
        model: {
            prop: 'dialogShow',
            event: 'change'
        },
        methods: {
            // checkAll(value){
            //     this.indeterminate = false
            //     this.groupVerifyList = this.groupVerifyList.map(item => {
            //         return {
            //             ...item,
            //             checked: value
            //         }
            //     })
            // },
            // changeSingle(value){
            //     let checkedflag = this.groupVerifyList.every(item => item.checked)
            //     let indeterminateflag = this.groupVerifyList.some(item => item.checked)
            //     this.checked = checkedflag
            //     this.indeterminate = checkedflag ? false : indeterminateflag
            //     this.groupVerifyList = [...this.groupVerifyList]
            // },
            // 审批
            edit(row, status){
                // console.log(row)
                this.$emit('edit', {
                    id: row.id,
                    status
                })
                // let res = await this.auditEdit()
                // console.log(res)
            },
            // agreeAll(){
            //     let _verifyList = this.groupVerifyList.filter(item => item.status == 1 && item.checked)
            //     if(!_verifyList.length) return
            //     let ids = _verifyList.map(item => item.id)
            // },
            onBeforeClose(done){
                this.$emit('change', false)
            },
            onChangeCurrent(page){
                this.$emit('toPage', page)
            }
        }
    }
</script>

<style lang="less">
.group_verify_popup{
    .alink{
        color:#1989fa;
        cursor:pointer;
        font-size:14px;
        text-decoration:none;
        margin-right: 10px;
    }
    .user-info{
        display: flex;
        align-items: center;
        .avatar{
            width: 25px;
            height: 25px;
            background-color: #f5f5f5;
            border-radius: 50%;
            margin-right: 12px;
        }
    }
    
}
</style>